import "../styles/blocks/home-page/steps-accordion.scss";

import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const Panel = ({ isActive, content, title, index, setActiveTab, activeTab, AnimatedContent }) => {
	const panelClasses = classNames({
		"steps-accordion__panel": true,
		"steps-accordion__panel--active": isActive
	});

	const changeActiveTab = (event) => {
		setActiveTab(activeTab === index ? -1 : index);

		if(activeTab === index) {
			return;
		}

		const header = document.getElementById("site-header");
		const headerHeight = +header?.offsetHeight - +( header &&window.getComputedStyle(header).getPropertyValue("--offset"));

		setTimeout(() => {
			window.scrollTo({
				top: event.target.offsetTop - headerHeight,
				behavior: "smooth"
			});
		}, 410)
	};

	return (
		<div className={panelClasses}>
			<button type="button" className="steps-accordion__button" onClick={changeActiveTab}>
				{title}
			</button>

			{AnimatedContent ? (
				<AnimatedContent isActive={isActive} content={content} />
			) : (
				isActive && (
					<div className="steps-accordion__inner">
						<div className="steps-accordion__content" dangerouslySetInnerHTML={{ __html: content }} />
					</div>
				)
			)}
		</div>
	);
};

const StepsAccordion = ({ steps }) => {
	const [activeTab, setActiveTab] = useState(0);
	const [AnimatedContent, setAnimatedContent] = useState(null);
	const element = useRef(null);

	useEffect(() => {
		let cancelled = false;
		let requested = false;
		let observer;

		const loadAnimations = () => {
			if (requested) return;
			requested = true;
			observer?.disconnect();

			import("./AnimatedStepsContent")
				.then(({ default: Content }) => {
					if (!cancelled) setAnimatedContent(() => Content);
				})
				.catch(error => console.error("Failed to load steps animations", error));
		};

		if (typeof IntersectionObserver === "undefined") {
			loadAnimations();
		} else {
			observer = new IntersectionObserver(entries => {
				if (entries.some(entry => entry.isIntersecting)) loadAnimations();
			});
			observer.observe(element.current);
		}

		return () => {
			cancelled = true;
			observer?.disconnect();
		};
	}, []);

	return (
		<div className="steps-accordion" ref={element}>
			{steps.map((step, index) => {
				const isActive = index === activeTab;

				return (
					<Panel
						key={index}
						title={step.title}
						content={step.content}
						isActive={isActive}
						index={index}
						setActiveTab={setActiveTab}
						activeTab={activeTab}
						AnimatedContent={AnimatedContent}
					/>
				);
			})}
		</div>
	);
};

StepsAccordion.propTypes = {
	steps: PropTypes.array.isRequired
}

export default StepsAccordion;
